import React from 'react';
import { creations } from '../data/creations';
export function CreationsGallery() {
  return <section aria-labelledby="creations-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-47" data-mp="lbu4bgr2aqp4">
      <div className="max-w-6xl mx-auto" data-id="element-48" data-mp="gczevvyla3w1">
        <div className="max-w-2xl mx-auto text-center" data-id="element-49" data-mp="gbo6tjy429z4">
          <p className="text-xs font-semibold tracking-[0.12em] text-coral-deep" data-id="element-50" data-mp="cc71qrmljeuh">
            DES IDÉES À CRÉER
          </p>
          <h2 id="creations-title" className="mt-3 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal text-balance" data-id="element-51" data-mp="7dm9bedl5zgl">
            Tout ce que vous pouvez créer{' '}
            <span className="italic font-medium text-coral-deep" data-id="element-52" data-mp="3trdqjvtbf8uo">avec cette technique</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-53" data-mp="3ou3uhxbf7yxv">
            Inspirez-vous de ces pièces et explorez les possibilités du faux vitrail.
          </p>
        </div>

        <ul className="mt-10 sm:mt-14 grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-6 sm:gap-y-8 lg:grid-cols-3" data-id="element-54" data-mp="3ftfgv3pxw0li">
          {creations.map(c => <li key={c.id} data-id="element-55" data-mp="1tkhm8jn84x57">
              <figure data-id="element-56" data-mp="1yciu7tdd01pf">
                <div className="aspect-[4/5] overflow-hidden rounded-[18px] bg-sand shadow-soft" data-id="element-57" data-mp="1yd2g1l64ra8q">
                  <img src={c.src} alt={c.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-58" data-mp="1klnsr256wmvv" />
                </div>
                <figcaption className="mt-3 text-center font-serif italic text-base sm:text-lg text-teal" data-id="element-59" data-mp="1on95mnhq5162">
                  {c.motif}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}